import { useEffect, useRef } from "react";

import { useAppSelector } from "store/index";
import { selectCurrentClassUser, selectCurrentCourse } from "store/selectors";
import { AutoMuteService } from "utils/auto-mute-service";

/**
 * Unified hook that handles all auto-mute scenarios:
 * - Breakout room returns
 * - Any other future auto-mute triggers
 */
export const useUnifiedAutoMute = () => {
  const currentClassUser = useAppSelector(selectCurrentClassUser);
  const currentCourse = useAppSelector(selectCurrentCourse);
  const previousBreakoutGroupId = useRef<string | null>(null);

  // Handle breakout return auto-mute
  useEffect(() => {
    const currentBreakoutGroupId = currentClassUser?.breakout_group_id || null;

    const scenario = AutoMuteService.detectScenario(
      currentClassUser || null,
      previousBreakoutGroupId.current,
    );

    if (scenario === "breakout_return" || scenario === "breakout_listening") {
      AutoMuteService.handleAutoMute(currentCourse, scenario);
    }

    // Update the previous state for next comparison
    previousBreakoutGroupId.current = currentBreakoutGroupId;
  }, [currentClassUser?.breakout_group_id, currentClassUser, currentCourse]);
};
